function cov_12qztpvkbs() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Header.tsx";
    var hash = "128ae383fc3269233449963d5f82199f451930ec";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Header.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 36,
                    column: 30
                },
                end: {
                    line: 36,
                    column: 89
                }
            },
            "1": {
                start: {
                    line: 38,
                    column: 27
                },
                end: {
                    line: 38,
                    column: 83
                }
            },
            "2": {
                start: {
                    line: 40,
                    column: 31
                },
                end: {
                    line: 40,
                    column: 91
                }
            },
            "3": {
                start: {
                    line: 42,
                    column: 24
                },
                end: {
                    line: 42,
                    column: 76
                }
            },
            "4": {
                start: {
                    line: 44,
                    column: 25
                },
                end: {
                    line: 183,
                    column: 2
                }
            },
            "5": {
                start: {
                    line: 46,
                    column: 18
                },
                end: {
                    line: 46,
                    column: 31
                }
            },
            "6": {
                start: {
                    line: 47,
                    column: 22
                },
                end: {
                    line: 47,
                    column: 35
                }
            },
            "7": {
                start: {
                    line: 48,
                    column: 18
                },
                end: {
                    line: 48,
                    column: 31
                }
            },
            "8": {
                start: {
                    line: 50,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 2
                }
            },
            "9": {
                start: {
                    line: 54,
                    column: 2
                },
                end: {
                    line: 54,
                    column: 45
                }
            },
            "10": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 56,
                    column: 61
                }
            },
            "11": {
                start: {
                    line: 62,
                    column: 5
                },
                end: {
                    line: 62,
                    column: 38
                }
            },
            "12": {
                start: {
                    line: 64,
                    column: 2
                },
                end: {
                    line: 64,
                    column: 53
                }
            },
            "13": {
                start: {
                    line: 67,
                    column: 2
                },
                end: {
                    line: 67,
                    column: 46
                }
            },
            "14": {
                start: {
                    line: 69,
                    column: 1
                },
                end: {
                    line: 86,
                    column: 39
                }
            },
            "15": {
                start: {
                    line: 70,
                    column: 46
                },
                end: {
                    line: 73,
                    column: 3
                }
            },
            "16": {
                start: {
                    line: 74,
                    column: 35
                },
                end: {
                    line: 77,
                    column: 3
                }
            },
            "17": {
                start: {
                    line: 79,
                    column: 2
                },
                end: {
                    line: 81,
                    column: 3
                }
            },
            "18": {
                start: {
                    line: 80,
                    column: 3
                },
                end: {
                    line: 80,
                    column: 61
                }
            },
            "19": {
                start: {
                    line: 83,
                    column: 2
                },
                end: {
                    line: 85,
                    column: 3
                }
            },
            "20": {
                start: {
                    line: 84,
                    column: 3
                },
                end: {
                    line: 84,
                    column: 39
                }
            },
            "21": {
                start: {
                    line: 88,
                    column: 26
                },
                end: {
                    line: 111,
                    column: 2
                }
            },
            "22": {
                start: {
                    line: 89,
                    column: 2
                },
                end: {
                    line: 108,
                    column: 3
                }
            },
            "23": {
                start: {
                    line: 94,
                    column: 23
                },
                end: {
                    line: 94,
                    column: 47
                }
            },
            "24": {
                start: {
                    line: 96,
                    column: 3
                },
                end: {
                    line: 107,
                    column: 4
                }
            },
            "25": {
                start: {
                    line: 98,
                    column: 5
                },
                end: {
                    line: 98,
                    column: 34
                }
            },
            "26": {
                start: {
                    line: 102,
                    column: 5
                },
                end: {
                    line: 102,
                    column: 31
                }
            },
            "27": {
                start: {
                    line: 104,
                    column: 5
                },
                end: {
                    line: 104,
                    column: 35
                }
            },
            "28": {
                start: {
                    line: 106,
                    column: 5
                },
                end: {
                    line: 106,
                    column: 28
                }
            },
            "29": {
                start: {
                    line: 110,
                    column: 2
                },
                end: {
                    line: 110,
                    column: 25
                }
            },
            "30": {
                start: {
                    line: 113,
                    column: 27
                },
                end: {
                    line: 144,
                    column: 2
                }
            },
            "31": {
                start: {
                    line: 114,
                    column: 35
                },
                end: {
                    line: 117,
                    column: 3
                }
            },
            "32": {
                start: {
                    line: 118,
                    column: 46
                },
                end: {
                    line: 121,
                    column: 3
                }
            },
            "33": {
                start: {
                    line: 122,
                    column: 29
                },
                end: {
                    line: 122,
                    column: 69
                }
            },
            "34": {
                start: {
                    line: 123,
                    column: 34
                },
                end: {
                    line: 126,
                    column: 3
                }
            },
            "35": {
                start: {
                    line: 127,
                    column: 31
                },
                end: {
                    line: 127,
                    column: 73
                }
            },
            "36": {
                start: {
                    line: 129,
                    column: 2
                },
                end: {
                    line: 143,
                    column: 4
                }
            },
            "37": {
                start: {
                    line: 146,
                    column: 27
                },
                end: {
                    line: 153,
                    column: 2
                }
            },
            "38": {
                start: {
                    line: 147,
                    column: 2
                },
                end: {
                    line: 152,
                    column: 4
                }
            },
            "39": {
                start: {
                    line: 155,
                    column: 1
                },
                end: {
                    line: 182,
                    column: 3
                }
            },
            "40": {
                start: {
                    line: 168,
                    column: 23
                },
                end: {
                    line: 168,
                    column: 41
                }
            },
            "41": {
                start: {
                    line: 185,
                    column: 0
                },
                end: {
                    line: 185,
                    column: 30
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 44,
                        column: 36
                    },
                    end: {
                        line: 44,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 55
                    },
                    end: {
                        line: 183,
                        column: 1
                    }
                },
                line: 44
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 69,
                        column: 17
                    },
                    end: {
                        line: 69,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 23
                    },
                    end: {
                        line: 86,
                        column: 2
                    }
                },
                line: 69
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 88,
                        column: 26
                    },
                    end: {
                        line: 88,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 88,
                        column: 32
                    },
                    end: {
                        line: 111,
                        column: 2
                    }
                },
                line: 88
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 113,
                        column: 27
                    },
                    end: {
                        line: 113,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 113,
                        column: 46
                    },
                    end: {
                        line: 144,
                        column: 2
                    }
                },
                line: 113
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 146,
                        column: 27
                    },
                    end: {
                        line: 146,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 146,
                        column: 46
                    },
                    end: {
                        line: 153,
                        column: 2
                    }
                },
                line: 146
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 168,
                        column: 17
                    },
                    end: {
                        line: 168,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 168,
                        column: 23
                    },
                    end: {
                        line: 168,
                        column: 41
                    }
                },
                line: 168
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 67,
                        column: 2
                    },
                    end: {
                        line: 67,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 67,
                            column: 2
                        },
                        end: {
                            line: 67,
                            column: 22
                        }
                    }, {
                        start: {
                            line: 67,
                            column: 26
                        },
                        end: {
                            line: 67,
                            column: 46
                        }
                    }],
                line: 67
            },
            "1": {
                loc: {
                    start: {
                        line: 79,
                        column: 2
                    },
                    end: {
                        line: 81,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 79,
                            column: 2
                        },
                        end: {
                            line: 81,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 79
            },
            "2": {
                loc: {
                    start: {
                        line: 83,
                        column: 2
                    },
                    end: {
                        line: 85,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 83,
                            column: 2
                        },
                        end: {
                            line: 85,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 83
            },
            "3": {
                loc: {
                    start: {
                        line: 83,
                        column: 6
                    },
                    end: {
                        line: 83,
                        column: 53
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 83,
                            column: 6
                        },
                        end: {
                            line: 83,
                            column: 26
                        }
                    }, {
                        start: {
                            line: 83,
                            column: 30
                        },
                        end: {
                            line: 83,
                            column: 39
                        }
                    }, {
                        start: {
                            line: 83,
                            column: 43
                        },
                        end: {
                            line: 83,
                            column: 53
                        }
                    }],
                line: 83
            },
            "4": {
                loc: {
                    start: {
                        line: 89,
                        column: 2
                    },
                    end: {
                        line: 108,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 89,
                            column: 2
                        },
                        end: {
                            line: 108,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 89
            },
            "5": {
                loc: {
                    start: {
                        line: 90,
                        column: 3
                    },
                    end: {
                        line: 92,
                        column: 27
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 90,
                            column: 3
                        },
                        end: {
                            line: 90,
                            column: 33
                        }
                    }, {
                        start: {
                            line: 91,
                            column: 3
                        },
                        end: {
                            line: 91,
                            column: 10
                        }
                    }, {
                        start: {
                            line: 92,
                            column: 3
                        },
                        end: {
                            line: 92,
                            column: 27
                        }
                    }],
                line: 90
            },
            "6": {
                loc: {
                    start: {
                        line: 96,
                        column: 3
                    },
                    end: {
                        line: 107,
                        column: 4
                    }
                },
                type: "switch",
                locations: [{
                        start: {
                            line: 97,
                            column: 4
                        },
                        end: {
                            line: 98,
                            column: 34
                        }
                    }, {
                        start: {
                            line: 99,
                            column: 4
                        },
                        end: {
                            line: 99,
                            column: 34
                        }
                    }, {
                        start: {
                            line: 100,
                            column: 4
                        },
                        end: {
                            line: 100,
                            column: 37
                        }
                    }, {
                        start: {
                            line: 101,
                            column: 4
                        },
                        end: {
                            line: 102,
                            column: 31
                        }
                    }, {
                        start: {
                            line: 103,
                            column: 4
                        },
                        end: {
                            line: 104,
                            column: 35
                        }
                    }, {
                        start: {
                            line: 105,
                            column: 4
                        },
                        end: {
                            line: 106,
                            column: 28
                        }
                    }],
                line: 96
            },
            "7": {
                loc: {
                    start: {
                        line: 160,
                        column: 7
                    },
                    end: {
                        line: 171,
                        column: 7
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 161,
                            column: 7
                        },
                        end: {
                            line: 164,
                            column: 9
                        }
                    }, {
                        start: {
                            line: 166,
                            column: 7
                        },
                        end: {
                            line: 170,
                            column: 9
                        }
                    }],
                line: 160
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0],
            "2": [0, 0],
            "3": [0, 0, 0],
            "4": [0, 0],
            "5": [0, 0, 0],
            "6": [0, 0, 0, 0, 0, 0],
            "7": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "128ae383fc3269233449963d5f82199f451930ec"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_12qztpvkbs = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_12qztpvkbs();
import { bindActionCreators } from '@reduxjs/toolkit';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from 'vio-components';
import { ENVIRONMENTS } from 'vio-constants';
import { useReduxState } from 'vio-libs';
import { isMapRoute } from '../../lib';
import { requestLocations, requestOrgNetworkInterfaces, resetMenus, setNetworkInterfacesAliases, setOrganization, setSiteIDMapping, setUserRoles } from '../../redux';
import OrganizationsDropdown from '../ui/OrganizationsDropdown';
import Navigation from './Navigation';
import SentryComponent from './Sentry';
import UserDetails from './UserDetails';
const kineticGridLogoCanary = (cov_12qztpvkbs().s[0]++, require('../../../images/svg/kinetic-grid-logo-canary.svg'));
const kineticGridLogoDev = (cov_12qztpvkbs().s[1]++, require('../../../images/svg/kinetic-grid-logo-dev.svg'));
const kineticGridLogoPreview = (cov_12qztpvkbs().s[2]++, require('../../../images/svg/kinetic-grid-logo-preview.svg'));
const kineticGridLogo = (cov_12qztpvkbs().s[3]++, require('../../../images/svg/kinetic-grid-logo.svg'));
const Header = (cov_12qztpvkbs().s[4]++, React.memo(() => {
    cov_12qztpvkbs().f[0]++;
    const dispatch = (cov_12qztpvkbs().s[5]++, useDispatch());
    const { pathname } = (cov_12qztpvkbs().s[6]++, useLocation());
    const navigate = (cov_12qztpvkbs().s[7]++, useNavigate());
    const homePage = (cov_12qztpvkbs().s[8]++, useReduxState('userSettings.homePage'));
    const { locations, requestingLocations, siteSlugs } = (cov_12qztpvkbs().s[9]++, useReduxState('locations'));
    const { orgNetworkInterfaces, requestingOrgNetworkInterfaces } = (cov_12qztpvkbs().s[10]++, useReduxState('networkInterfaces'));
    const { allUserRoles, email, manage_users: manageUsers, picture } = (cov_12qztpvkbs().s[11]++, useReduxState('user'));
    const { organization, organizations } = (cov_12qztpvkbs().s[12]++, useReduxState('organizations'));
    const isHomePageCurrentMapView = (cov_12qztpvkbs().s[13]++, (cov_12qztpvkbs().b[0][0]++, isMapRoute(pathname)) && (cov_12qztpvkbs().b[0][1]++, isMapRoute(homePage)));
    cov_12qztpvkbs().s[14]++;
    React.useEffect(() => {
        cov_12qztpvkbs().f[1]++;
        const setNetworkInterfacesAliasesDispatch = (cov_12qztpvkbs().s[15]++, bindActionCreators(setNetworkInterfacesAliases, dispatch));
        const setSiteIDMappingDispatch = (cov_12qztpvkbs().s[16]++, bindActionCreators(setSiteIDMapping, dispatch));
        cov_12qztpvkbs().s[17]++;
        if (!requestingOrgNetworkInterfaces) {
            cov_12qztpvkbs().b[1][0]++;
            cov_12qztpvkbs().s[18]++;
            setNetworkInterfacesAliasesDispatch(orgNetworkInterfaces);
        }
        else {
            cov_12qztpvkbs().b[1][1]++;
        }
        cov_12qztpvkbs().s[19]++;
        if ((cov_12qztpvkbs().b[3][0]++, !requestingLocations) && (cov_12qztpvkbs().b[3][1]++, locations) && (cov_12qztpvkbs().b[3][2]++, !siteSlugs)) {
            cov_12qztpvkbs().b[2][0]++;
            cov_12qztpvkbs().s[20]++;
            setSiteIDMappingDispatch(locations);
        }
        else {
            cov_12qztpvkbs().b[2][1]++;
        }
    }, [orgNetworkInterfaces, locations]);
    cov_12qztpvkbs().s[21]++;
    const renderHeaderLogo = () => {
        cov_12qztpvkbs().f[2]++;
        cov_12qztpvkbs().s[22]++;
        if ((cov_12qztpvkbs().b[5][0]++, typeof vaporio !== 'undefined') && (cov_12qztpvkbs().b[5][1]++, vaporio) && (cov_12qztpvkbs().b[5][2]++, vaporio.environment_name)) {
            cov_12qztpvkbs().b[4][0]++;
            const environment = (cov_12qztpvkbs().s[23]++, vaporio.environment_name);
            cov_12qztpvkbs().s[24]++;
            switch (environment) {
                case ENVIRONMENTS.CANARY:
                    cov_12qztpvkbs().b[6][0]++;
                    cov_12qztpvkbs().s[25]++;
                    return kineticGridLogoCanary;
                case ENVIRONMENTS.DEVELOPMENT:
                    cov_12qztpvkbs().b[6][1]++;
                case ENVIRONMENTS.DEVELOPMENT_V2:
                    cov_12qztpvkbs().b[6][2]++;
                case ENVIRONMENTS.NIGHTLY:
                    cov_12qztpvkbs().b[6][3]++;
                    cov_12qztpvkbs().s[26]++;
                    return kineticGridLogoDev;
                case ENVIRONMENTS.PREVIEW:
                    cov_12qztpvkbs().b[6][4]++;
                    cov_12qztpvkbs().s[27]++;
                    return kineticGridLogoPreview;
                default:
                    cov_12qztpvkbs().b[6][5]++;
                    cov_12qztpvkbs().s[28]++;
                    return kineticGridLogo;
            }
        }
        else {
            cov_12qztpvkbs().b[4][1]++;
        }
        cov_12qztpvkbs().s[29]++;
        return kineticGridLogo;
    };
    cov_12qztpvkbs().s[30]++;
    const renderOrgDropdown = () => {
        cov_12qztpvkbs().f[3]++;
        const requestLocationsDispatch = (cov_12qztpvkbs().s[31]++, bindActionCreators(requestLocations, dispatch));
        const requestOrgNetworkInterfacesDispatch = (cov_12qztpvkbs().s[32]++, bindActionCreators(requestOrgNetworkInterfaces, dispatch));
        const resetMenusDispatch = (cov_12qztpvkbs().s[33]++, bindActionCreators(resetMenus, dispatch));
        const setOrganizationDispatch = (cov_12qztpvkbs().s[34]++, bindActionCreators(setOrganization, dispatch));
        const setUserRolesDispatch = (cov_12qztpvkbs().s[35]++, bindActionCreators(setUserRoles, dispatch));
        cov_12qztpvkbs().s[36]++;
        return React.createElement(OrganizationsDropdown, {
            allUserRoles: allUserRoles,
            organization: organization,
            organizations: organizations,
            manageUsers: manageUsers,
            requestLocations: requestLocationsDispatch,
            requestOrgNetworkInterfaces: requestOrgNetworkInterfacesDispatch,
            resetMenus: resetMenusDispatch,
            setOrganization: setOrganizationDispatch,
            setUserRoles: setUserRolesDispatch
        });
    };
    cov_12qztpvkbs().s[37]++;
    const renderUserDetails = () => {
        cov_12qztpvkbs().f[4]++;
        cov_12qztpvkbs().s[38]++;
        return React.createElement(UserDetails, {
            email: email,
            picture: picture
        });
    };
    cov_12qztpvkbs().s[39]++;
    return React.createElement("header", {
        id: "header"
    }, React.createElement(React.Suspense, {
        fallback: React.createElement(Loader, null)
    }, React.createElement(SentryComponent, {
        style: {
            color: '#FFFFFF'
        }
    }, React.createElement("div", {
        id: "left"
    }, isHomePageCurrentMapView ? (cov_12qztpvkbs().b[7][0]++, React.createElement("img", {
        className: "logo pe-none",
        src: renderHeaderLogo()
    })) : (cov_12qztpvkbs().b[7][1]++, React.createElement("img", {
        className: "logo",
        onClick: () => {
            cov_12qztpvkbs().f[5]++;
            cov_12qztpvkbs().s[40]++;
            return navigate(homePage);
        },
        src: renderHeaderLogo()
    }))), React.createElement("nav", {
        id: "right"
    }, React.createElement(Navigation, null), renderOrgDropdown(), renderUserDetails()))));
}));
cov_12qztpvkbs().s[41]++;
Header.displayName = 'Header';
export default Header;
